/**
 * EcsCompactRow — compact ECS cluster row for Stack View.
 *
 * Shows the cluster name and a StatusBadge per ECS service (BR-U5-12).
 * Aggregate cluster health is derived from the worst service status (BR-09).
 */
import type { EcsCluster } from '@/types';
import { StatusBadge } from '../primitives/StatusBadge';
import styles from './EcsCompactRow.module.css';

export interface EcsCompactRowProps {
  cluster: EcsCluster;
}

export function EcsCompactRow({ cluster }: EcsCompactRowProps) {
  return (
    <div
      className={styles.row}
      aria-label={`${cluster.clusterName} — ${cluster.services.length} service${cluster.services.length !== 1 ? 's' : ''}`}
    >
      <span className={styles.clusterName} title={cluster.clusterName}>
        {cluster.clusterName}
      </span>
      <div className={styles.services}>
        {cluster.services.map((svc) => (
          <div key={svc.serviceName} className={styles.service}>
            <StatusBadge status={svc.serviceStatus} size="sm" label={svc.serviceName} />
            <span className={styles.counts} aria-hidden="true">
              {svc.runningCount}/{svc.desiredCount}
            </span>
          </div>
        ))}
        {cluster.services.length === 0 && (
          <span className={styles.noServices}>No services</span>
        )}
      </div>
    </div>
  );
}
